<template>
  <div
    class="w-full h-full fixed inset-0 lg:inset-0 lg:flex items-start lg:justify-center lg:p-8 dialog"
  >
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
    </div>
    <div
      class="fixed flex flex-col bg-white shadow-xl transform transition-all lg:max-w-3xl"
      :class="{ 'w-full': fullWidth }"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <nav :class="['sticky z-50 title py-4 px-6 flex items-center justify-between', bg.head]">
        <h2 class="text-xl">{{ head }}</h2>
        <base-button-icon icon="close" @click="$emit('close')" :class="[bg.icon]" />
      </nav>
      <div class="py-4 px-6">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import BaseButtonIcon from './_base-button-icon.vue'

export default {
  components: {
    BaseButtonIcon,
  },

  props: {
    fullWidth: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    head() {
      return this.$te(`mygwf.components.Modal.${this.$attrs.head}`)
        ? this.$t(`mygwf.components.Modal.${this.$attrs.head}`)
        : this.$attrs.head
    },
    bg() {
      return typeof this.$attrs.bg === 'undefined'
        ? {head: 'bg-primary text-white', icon: 'bg-primary hover:bg-primary-dark'}
        : {head: `bg-${this.$attrs.bg}`, icon: `bg-${this.$attrs.bg}`}
    },
  },
}
</script>

<style scoped>
.dialog {
  z-index: 2000;
}
</style>
